var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValueFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1519 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:0em;}.cls-2{letter-spacing:0em;}.cls-3,.cls-4{fill:#fff;}.cls-5{letter-spacing:0em;}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0em;}.cls-9,.cls-4{font-family:MyriadPro-Regular, 'Myriad Pro';font-size:21px;}.cls-10{letter-spacing:0em;}.cls-11{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:-.03em;}.cls-14{letter-spacing:-.03em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 103,
    cy: 167.02,
    r: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,65.02c56.24,0,102,45.76,102,102s-45.76,102-102,102S1,223.26,1,167.02,46.76,65.02,103,65.02m0-1C46.11,64.02,0,110.13,0,167.02s46.11,103,103,103,103-46.11,103-103-46.11-103-103-103h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "103 138.68 87.79 147.23 72.58 138.68 72.58 121.57 87.79 113.02 103 121.57 103 138.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.76 138.59 126.54 147.14 111.33 138.59 111.33 121.48 126.54 112.93 141.76 121.48 141.76 138.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.76 138.59 50.54 147.14 35.33 138.59 35.33 121.48 50.54 112.93 65.76 121.48 65.76 138.59"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(35.37 168.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "seed dist"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 77.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 84.63,
    y: 0
  }, "ibu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 113.06,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.89,
    y: 0
  }, "or")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 324,
    cy: 166.83,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,117.83c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 658,
    cy: 166.83,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658,117.83c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 494,
    cy: 166.83,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,117.83c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 373.5,
    y1: 166.33,
    x2: 443.5,
    y2: 166.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 543.5,
    y1: 166.33,
    x2: 607.5,
    y2: 166.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(629.86 176.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "epoch")), /*#__PURE__*/React.createElement("polygon", {
    points: "338.76 174.4 323.54 182.96 308.33 174.4 308.33 157.3 323.54 148.74 338.76 157.3 338.76 174.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "592.64 187.84 575.65 178.83 558.7 187.92 561.89 168.75 548.12 155.21 567.09 152.36 575.54 134.9 584.07 152.32 603.05 155.07 589.35 168.68 592.64 187.84"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(543.75 125.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.01,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 27.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 34.08,
    y: 0
  }, "ker")), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 205.96,
    y1: 167.5,
    x2: 273.96,
    y2: 166.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.76 177.59 493.54 186.14 478.33 177.59 478.33 160.48 493.54 151.93 508.76 160.48 508.76 177.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1416,
    cy: 166.02,
    r: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416,64.02c56.24,0,102,45.76,102,102s-45.76,102-102,102h0c-56.24,0-102-45.76-102-102s45.76-102,102-102h0m0-1c-56.89,0-103,46.11-103,103s46.11,103,103,103c56.89,0,103-46.11,103-103s-46.11-103-103-103h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1416 194.36 1431.21 185.8 1446.42 194.36 1446.42 211.46 1431.21 220.02 1416 211.46 1416 194.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1377.24 194.45 1392.46 185.89 1407.67 194.45 1407.67 211.55 1392.46 220.11 1377.24 211.55 1377.24 194.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1453.24 194.45 1468.46 185.89 1483.67 194.45 1483.67 211.55 1468.46 220.11 1453.24 211.55 1453.24 194.45"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(1483.63 164.68) rotate(-180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "seed dist"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 77.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 84.63,
    y: 0
  }, "ibu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 113.06,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.89,
    y: 0
  }, "or")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1195,
    cy: 166.2,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195,117.2c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49h0m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 861,
    cy: 166.2,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,117.2c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49h0m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1025,215.7c-27.29,0-49.5-22.21-49.5-49.5s22.21-49.5,49.5-49.5,49.5,22.21,49.5,49.5-22.21,49.5-49.5,49.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025,117.2c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1145.5,
    y1: 166.7,
    x2: 1075.5,
    y2: 166.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 975.5,
    y1: 166.7,
    x2: 911.5,
    y2: 166.7
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(889.14 156.87) rotate(-180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "epoch")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1180.24 158.63 1195.46 150.08 1210.67 158.63 1210.67 175.74 1195.46 184.29 1180.24 175.74 1180.24 158.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "926.36 148.2 943.35 157.21 960.3 148.11 957.11 167.29 970.88 180.83 951.91 183.67 943.46 201.13 934.93 183.72 915.95 180.97 929.65 167.36 926.36 148.2"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(915.93 134.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.01,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 27.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 34.08,
    y: 0
  }, "ker")), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1313.04,
    y1: 165.54,
    x2: 1245.04,
    y2: 166.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1010.24 155.45 1025.46 146.89 1040.67 155.45 1040.67 172.55 1025.46 181.11 1010.24 172.55 1010.24 155.45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.96,
    y: 131.5,
    width: 352,
    height: 89,
    transform: "translate(935.96 -583.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(756.84 119.97) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.03,
    y: 0
  }, "alue "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 52.65,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 62.33,
    y: 0
  }, "il"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 72.2,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.02,
    y: 0
  }, "er")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueFilter);
export default __webpack_public_path__ + "static/media/value-filter.fa5de4e875d20dd2cba70832d4a07b28.svg";
export { ForwardRef as ReactComponent };